/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import {
  httpClient, BASE_URL, PORTS, SERVICES, PATH_EXTENSION,
} from '@/middlewares/httpClient';
import { Workspace } from './models';

const key: string = 'flowmanager';
const port: string = PORTS.get(key);
const service: string = SERVICES.get(key);

const FLOW_MANAGER: string = `${BASE_URL}:${port}${PATH_EXTENSION}/${service}`;

const getWorkspaces = (userId: string) => httpClient
  .get(`${FLOW_MANAGER}/users/${userId}/workspaces`);

const getWorkspace = (workspaceId: string) => httpClient
  .get(`${FLOW_MANAGER}/workspaces/${workspaceId}`);

const addMember = (workspaceId: string, email: string) => httpClient
  .post(`${FLOW_MANAGER}/workspaces/${workspaceId}/members`, { email });

const deleteMember = (workspaceId: string, memberId: string) => httpClient
  .delete(`${FLOW_MANAGER}/workspaces/${workspaceId}/members/${memberId}`);

const updateWorkspace = (w: Workspace) => httpClient
  .put(`${FLOW_MANAGER}/workspaces/${w.id}`, w);

const addWorkspace = (name: string, owner: any) => httpClient
  .post(`${FLOW_MANAGER}/workspaces`, { name, owner });

const deleteWorkspace = (workspaceId: string) => httpClient
  .delete(`${FLOW_MANAGER}/workspaces/${workspaceId}`);

export {
  getWorkspaces,
  getWorkspace,
  addMember,
  deleteMember,
  updateWorkspace,
  addWorkspace,
  deleteWorkspace,
};
